import { Input } from "antd";
import i18n from "i18next";
import type { FC } from "react";
import { v4 as uuidv4 } from "uuid";

import { SecondaryButton } from "../../../Buttons/components/ActionButton";
import { Icon } from "../../../Icon";
import { IconCodes } from "../../../Icon/IconCodes";
import type { AntCustomFormField } from "../../types/types";
import { buttonStyle, InputGeneratorContainerStyle, inputStyle } from "../SiteIdGenerator/buttonGeneratorStyle";

export interface InputGeneratorProps extends AntCustomFormField<string> {
    label: string;
    readOnly: boolean;
    name: string;
}

export const generateCode = () => {
    return uuidv4().replaceAll("-", "");
};

export const InputGenerator: FC<InputGeneratorProps> = ({ readOnly, onChange, ...restProps }) => {
    const onClick = () => {
        if (onChange) {
            onChange(generateCode());
        }
    };

    return (
        <InputGeneratorContainerStyle>
            <Input.Group compact>
                <Input readOnly={true} placeholder={i18n.t("enum.hostIdType.generate")} style={inputStyle} {...restProps} />
                <SecondaryButton
                    name="contractCode_button"
                    onClick={onClick}
                    disabled={readOnly}
                    icon={<Icon iconName={IconCodes.RedoOutlined} />}
                    style={buttonStyle}
                />
            </Input.Group>
        </InputGeneratorContainerStyle>
    );
};
